import { RequestCriteria } from './request-criteria';

export interface Transformations {
  sort: Sort[] | null;
  filters: RequestCriteria;
  page: Page;
}

export interface Sort {
  active: string;
  direction: SortDirection;
  /**
   * Porządek wartości kolumny przy sortowaniu w pamięci (z ColumnDefinition.sortValues), od
   * "najmniejszej" do "największej". Serwer o nim nie wie - SortBy tego nie przenosi.
   */
  valueOrder?: string[];
}

export interface Page {
  pageIndex: number;
  pageSize: number;
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc'
}
